import { HttpClient } from "@angular/common/http";
import { Injectable, Inject } from "@angular/core";
import { BehaviorSubject, catchError, Observable, of, tap } from "rxjs";
import { cancelInput } from "../../../inputs";
import { HttpService } from "../http.service";
import { ShippingMethodResponse, SubmitResponse } from "../../../models";
import { CompanyCreateEditInput, CompanyToggleInput, MethodCreateEditInput, MethodToggleInput } from "../../../inputs/shipping.input";

@Injectable({
    providedIn: 'root'
})
export class ShippingMethodService extends HttpService<any | cancelInput, ShippingMethodResponse> {


    private shippingMethodListSubject = new BehaviorSubject<ShippingMethodResponse | null>(null);
    readonly shippingMethodList$ = this.shippingMethodListSubject.asObservable();
    constructor(
        httpClient: HttpClient,
        @Inject('API_URL') apiUrl: string,
        @Inject('API_VERSION') apiVersion: string
    ) {
        super(httpClient, apiUrl, apiVersion, 'shipping');
    }


    // method

    getShippingMethods(page = 1, limit = 10): Observable<ShippingMethodResponse | null> {
        return this.getPagedGeneral('shipping/method', page, limit).pipe(
            tap(response => this.shippingMethodListSubject.next(response)),
            catchError(() => of(null))
        );
    }
    getFilteredShippingMethods(entity: any): Observable<ShippingMethodResponse | null> {
        return this.filterAllActionPaged(entity, 'method').pipe(
            tap((response) => this.shippingMethodListSubject.next(response)),
            catchError(() => of(null))
        );
    }
    deleteShippingMethodById(methodId: string): Observable<SubmitResponse> {
        return this.delete(methodId, 'method');
    }
    createShippingMethod(methodInput: MethodCreateEditInput): Observable<SubmitResponse> {
        return this.create(methodInput, 'method').pipe(catchError((error) => of(error)));
    }
    editShippingMethod(methodInput: MethodCreateEditInput): Observable<SubmitResponse> {
        return this.update(methodInput, 'method').pipe(catchError((error) => of(error)));
    }
    toggleShippingMethod(methodInput: MethodToggleInput): Observable<SubmitResponse> {
        return this.update(methodInput, 'method').pipe(catchError((error) => of(error)));
    }


}